"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducer = createReducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _social = require("../../types/social");
var _action_types = require("../../constants/action_types");
var _defaultState = require("./defaultState");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultState.defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _action_types.SOCIAL_CREATE_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        create: _objectSpread(_objectSpread({}, state.create), {}, {
          status: action.status,
          errorType: action.status === _social.ECreateStatus.Failed ? action.errorType : action.status === _social.ECreateStatus.Succeed ? undefined : state.create.errorType,
          error: action.status === _social.ECreateStatus.Failed ? action.error : action.status === _social.ECreateStatus.Succeed ? undefined : state.create.error
        })
      });
  }
  return state;
}